module.exports = __webpack_public_path__ + "static/iceCaves.9b7d35cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surroundings/iceCaves.jpg
// module id = 416
// module chunks = 23221215298982